import React from 'react';
import { CsrfTokenContext } from './CsrfTokenContext';
const useCsrfToken = () => React.useContext(CsrfTokenContext);
export default useCsrfToken;
